module.exports = __webpack_public_path__ + "static/media/KozGoPr6N-Regular.35f4c8e7.svg";